export default "__VITE_ASSET__6wwGNdRh__"